module.exports = __webpack_public_path__ + "img/direct-right.0cd039fd.svg";